import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '../components/ui/button';
import { ArrowLeft, RotateCcw } from 'lucide-react';
import LabelDiagram from '../components/slides/activity/LabelDiagram';
import type { Slide } from '../../utils/supabase/client';

export default function DemoLabelDiagram() {
  const navigate = useNavigate();
  const [key, setKey] = useState(0);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  // Demo slide data
  const demoSlide: Slide = {
    id: 'demo-label-diagram',
    lesson_id: 'demo',
    type: 'label_diagram',
    slide_order: 0,
    created_at: new Date().toISOString(),
    content: {
      title: 'Label the Plant Cell',
      instructions: 'Drag the labels to the correct positions on the diagram',
      labels: [
        { id: 'Chloroplast', text: 'Chloroplast', correctPosition: { x: 35, y: 40 } },
        { id: 'Cell Wall', text: 'Cell Wall', correctPosition: { x: 15, y: 30 } },
        { id: 'Nucleus', text: 'Nucleus', correctPosition: { x: 50, y: 50 } },
        { id: 'Vacuole', text: 'Vacuole', correctPosition: { x: 65, y: 55 } },
        { id: 'Mitochondria', text: 'Mitochondria', correctPosition: { x: 40, y: 65 } },
        { id: 'Cell Membrane', text: 'Cell Membrane', correctPosition: { x: 20, y: 50 } },
      ],
    },
  };

  const handleSubmit = (answer: any) => {
    setHasSubmitted(true);
    console.log('Label diagram submitted:', answer);
  };

  const handleAnswerChange = (_answer: any) => {
    // Labels are tracked internally by the component
  };

  const handleRestart = () => {
    setHasSubmitted(false);
    setKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-background to-green-50 dark:from-teal-950/20 dark:via-background dark:to-green-950/20">
      {/* Header */}
      <header className="border-b border-border bg-card/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Button variant="ghost" onClick={() => navigate('/demos')}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Demos
            </Button>
            <Button variant="outline" onClick={handleRestart}>
              <RotateCcw className="w-4 h-4 mr-2" />
              Reset
            </Button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Label Diagram Demo</h1>
          <p className="text-muted-foreground text-sm md:text-base">
            Drag labels to their correct positions on the diagram. Perfect for anatomy and structure review!
          </p>
        </div>

        <LabelDiagram
          key={key}
          slide={demoSlide}
          onSubmit={handleSubmit}
          onAnswerChange={handleAnswerChange}
          selectedAnswer={null}
          hasSubmitted={hasSubmitted}
        />
      </div>
    </div>
  );
}
